const createArticleService = ({ store }) => {
  const getAllArticles = () => {
    const seen = new Set()

    store.productCollection.getAll().forEach(cart => {
      seen.add(cart.product.productCode)
    })

    return [...seen]
  }

  const getActiveArticles = () => {
    const seen = new Set()

    store.productCollection.getAll().forEach(cart => {
      if (cart.isActive !== false) {
        seen.add(cart.product.productCode)
      }
    })

    return [...seen]
  }

  return { getAllArticles, getActiveArticles }
}

export { createArticleService }
export default createArticleService
